import React, { Component } from "react";
import { connect } from "react-redux";

import { HallsActionCreators } from "../../../actions/actionCreators";
import { hallsStoreSelectors } from "../../../store/store";
import { ActionCreator } from "../../../../../actions/actions";

import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import "./UploadConfiguration.component.scss";

import { HallServer } from "../../../reducers/inspectingHall.reducer";
import { HallBaseConfig } from "../../../reducers/hallsList.reducer";

export interface UploadConfigurationProps {
    creationMode: any;
    inspectingHall: HallBaseConfig;
    inspectingServer: HallServer;
    uploadConfiguration: ActionCreator;
}

interface UploadConfigurationState {
    uploadFile: any | null;
    error: string | null;
}

class UploadConfiguration extends Component<
    UploadConfigurationProps,
    UploadConfigurationState
> {
    constructor(props) {
        super(props);
        this.state = {
            uploadFile: null,
            error: null
        };
    }

    onUpload = () => {
        const subsidiary = this.props.inspectingHall.subsidiary.id;
        const server_type = this.props.inspectingServer.type;
        const server_id = this.props.inspectingServer.id;
        const system_version = this.props.inspectingServer.system_server_version;

        this.props.uploadConfiguration(
            subsidiary,
            server_type,
            server_id,
            system_version,
            this.state.uploadFile
        );
    };

    handleFile = e => {
        if (e.length > 0) {
            const size = e[0].size / 1024 / 1024;
            if (size <= 100) {
                this.setState({
                    uploadFile: e[0],
                    error: null
                });
            } else {
                this.setState({
                    uploadFile: null,
                    error: "Max. Size of 100mb for upload file."
                });
            }
        } else {
            this.setState({
                uploadFile: null,
                error: null
            });
        }
    };

    render() {
        return (
            <div id="upload-configuration">
                <div className="upload-content">
                    <div>
                        <div className="editing-warning">
                            <i className="icon-exclamation-circle-light" />
                            Configuration upload is only available for servers with the same system server version of the same hall
                        </div>
                        <div id="upload" className="row">
                            <div className="col-12">
                                <div className="label-tooltip">
                                    <label className="label">
                                        Configuration File (.SSC)
                                    </label>
                                </div>
                                <Components.FileBox
                                    displayMessage="Drag and drop SSC file"
                                    multipleFilesAllowed={false}
                                    displayIcon={""}
                                    onFilesChange={this.handleFile}
                                    files={[]}
                                />
                                {this.state.error && (
                                    <label className="input-error">
                                        {this.state.error}
                                    </label>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="red-btn upload-btn"
                                    onClick={this.onUpload}
                                    disabled={this.state.uploadFile == null}
                                >
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: hallsStoreSelectors.creationMode(state)
});

const mapDispatchToProps = {
    uploadConfiguration: HallsActionCreators.uploadConfiguration
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadConfiguration);
